export default __webpack_public_path__ + "static/media/key.020c2c8f.svg";